import {LongTaskItemCbInt} from "../LongTaskItem/UseLongTask";
import {useEffect, useState} from "react";

interface UseTimerTaskInt
{
    count: number //0 unlimit
    delay?:number
    onTick: ()=>void
}
interface UseTimerTaskControlInt
{
    (data?:any):void
}

const  UseTimerTask = (onTick: UseTimerTaskControlInt,count:number,delay?:number): [ UseTimerTaskControlInt, UseTimerTaskControlInt] =>{

    const [tick, setTick] = useState(-1)

    useEffect(()=>{
        if(tick < 0 )return
        if(tick > count && count>0) return

        const timerId = setInterval (()=>{
            onTick(tick)
            setTick((prevState)=>prevState+1)
        },delay ? delay : 2000)
        return () => clearInterval(timerId)
    },[tick])

    const start = ()=>{
        setTick(0)
    }

    const stop = () => {
        setTick(-1)
    }

    return [start,stop]
}
export default UseTimerTask

